import { useTranslation } from 'react-i18next';
import { useClientContext } from '../../ClientContext';
import { useScorecard } from '../../Scorecard';
import { IncomeAndSpendingButton } from './IncomeAndSpendingButton';

export const AnnualIncomeButton = ({ linkTo }: { linkTo: string }) => {
  const { t: tCommon } = useTranslation('common');
  const { householdID } = useClientContext();
  const { scorecard, scorecardQuery } = useScorecard({ householdID });

  if (scorecardQuery.isLoading || !scorecard)
    return <div className="animate-pulse bg-darkMode-gray-medium/20  rounded-2xl h-20 w-full" />;

  return (
    <IncomeAndSpendingButton
      to={linkTo}
      value={scorecard.annualIncome}
      label={tCommon('annual-income-button-title')}
      linkState={{ viewIndex: 0 }}
    />
  );
};
